<template>
  <div class="mobile-verification-container">
    <p v-if="vehicleString" class="font-weight-bold text-dark" data-test="vehicleName">{{ vehicleString }}</p>
    <h1 class="mt-4" data-test="welcomeBackHeader">
      {{
        $t('message.credit.returnToFinanceApp.mobileVerification.welcomeBack', { name: consumerBasicInfo.firstName })
      }}
    </h1>
    <p
      class="col-sm-10 pl-0"
      data-test="verificationCodeMsg"
      v-html-safe="
        $t('message.credit.returnToFinanceApp.mobileVerification.codeMsg', {
          phoneNumber: formattedPhoneNumber,
          business: getBusinessName,
        })
      "
    ></p>
    <mobialis-form-with-validation
      @onValidate="verify"
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <div class="mb-5 pb-5">
        <MobialisTextInputWithValidation
          class="col-12 col-sm-7 px-0"
          rules="required|length:4"
          vid="code"
          v-model="code"
          :label="$t('message.credit.returnToFinanceApp.mobileVerification.enterCode')"
          data-cy="code"
          type="number"
          inputmode="numeric"
        ></MobialisTextInputWithValidation>
        <small data-cy="resendCodeMessage">
          {{ resendCodeMessage }}
          <span class="resend-code font-weight-bold pl-3" @click="resendCode()">
            {{ $t('message.common.mobileVerification.resendCode') }}
          </span>
        </small>
      </div>
      <mobialis-button type="submit" class="verify-button" data-cy="verifyCode">{{
        $t('message.common.continue')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ReturningCustomerMobileVerification',
  data() {
    return {
      code: '',
      codeResent: false,
    };
  },
  computed: {
    ...mapGetters({
      getBusinessName: 'business/getBusinessName',
      vehicleString: 'vehicle/vehicleString',
      financeApplicationIsComplete: 'lead/financeApplicationIsComplete',
      financeApplicationIsExpired: 'lead/financeApplicationIsExpired',
    }),
    ...mapState('lead', ['consumerBasicInfo']),
    formattedPhoneNumber() {
      const number = this.consumerBasicInfo.phoneNumber;
      const lineNumber = number.slice(6, 10);
      return `(***) ***-${lineNumber}`;
    },
    resendCodeMessage() {
      if (!this.codeResent) {
        return this.$t('message.credit.returnToFinanceApp.mobileVerification.noCodeMsg');
      }
      return this.$t('message.credit.returnToFinanceApp.mobileVerification.codeResentMessage');
    },
  },
  methods: {
    async resendCode() {
      try {
        this.codeResent = true;
        await this.$store.dispatch('lead/sendMobileOtp');
      } catch (error) {
        this.$router.push('returning-customer-mobile-verification-error');
        this.$log('Error in resending verification code in ReturningCustomerMobileVerification', error);
      } finally {
        setTimeout(() => {
          this.codeResent = false;
        }, 30000);
      }
    },
    async verify(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/verifyMobileOtp', this.code);
        if (this.$store.state.business.info.creditSettings.enableSSNCapture === true) {
          this.$router.push('social-security');
        } else {
          this.$router.push('employer-form');
        }
      } catch (err) {
        this.$router.push('returning-customer-mobile-verification-error');
        this.$log('Error in verifyMobileOtp ReturningCustomerMobileVerification', err);
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from && from.path && from.path.includes('returning-customer-mobile-verification-error')) {
        vm.resendCode();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';
.mobile-verification-container {
  @media (min-width: 575px) {
    min-height: 65vh;
    position: relative;
  }
}
small {
  font-size: 14px;
}
.resend-code {
  display: inline-block;
  color: $primary;
  cursor: pointer;
  font-size: 14px;
}
.verify-button {
  @media (min-width: 575px) {
    position: absolute;
    bottom: 0;
  }
}
</style>
